import { GameContext } from '../../../contexts/GameContext';
import { ProfileContext } from '../../../contexts/ProfileContext';
import { ZdarKidsGameContext } from '../../../contexts/ZdarKidsGameContext';
import { ZdarKidsGameStepConfiguration } from '../../../configuration/games/zdar-kids-game/zdarKidsGameContentConfiguration';
import React, { useContext, useState } from 'react';
import back from '../../../assets/images/games/zdar-kids-game/toolbar-back.webp';
import map from '../../../assets/images/games/zdar-kids-game/toolbar-map.webp';
import report from '../../../assets/images/games/zdar-kids-game/toolbar-report.webp';
import solution from '../../../assets/images/games/zdar-kids-game/toolbar-solution.webp';

type Props = {
    onOpenMap: () => void;
    onOpenReport: () => void;
    closeAudio: () => void;
};
export default function ZdarKidsGameToolbar(props: Props) {
    const [selectedTab, setSelectedTab] = useState(1);
    const [dragging, setDragging] = useState(false);

    const {
        solutionModalOpen,
        setSolutionModalOpen,
        setReportOpen,
        reportOpen,
        setMapOpen,
        mapOpen,
        solutionModalEnabled,
    } = useContext(ZdarKidsGameContext);
    const { stepContent, currentStep } = useContext(GameContext);
    const { availableGame } = useContext(ProfileContext);

    const { hints } = stepContent as ZdarKidsGameStepConfiguration;

    const handleClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>, i: number) => {
        e.preventDefault();
        if (!dragging) {
            onClickItem(i);
        }
        setDragging(false);
    };

    const handleTouch = (e: React.TouchEvent<HTMLDivElement>, i: number) => {
        e.preventDefault();
        if (!dragging) {
            onClickItem(i);
        }
        setDragging(false);
    };

    const onClickItem = (i: number) => {
        props.closeAudio();
        setSelectedTab(i);
        if (i === 1) {
            setSolutionModalOpen(!solutionModalOpen);
            setReportOpen(false);
            setMapOpen(false);
            window.scrollTo(0, 0);
        }
        if (i === 2) {
            setMapOpen(!mapOpen);
            setReportOpen(false);
            props.onOpenMap();
            window.scrollTo(0, 0);
        }
        if (i === 3) {
            setMapOpen(false);
            setReportOpen(!reportOpen);
            props.onOpenReport();
            window.scrollTo(0, 0);
        }
    };

    const isActive = (i: number) => {
        return selectedTab === i;
    };

    const getTabClass = (i: number) => {
        return isActive(i) ? 'menu__item active' : 'menu__item';
    };

    const iconSize = (i: number) => {
        return isActive(i) ? 60 : 60;
    };

    const stat = '_' + currentStep;
    // @ts-expect-error
    const hintsTaken = availableGame !== undefined ? availableGame?.stats[stat]?.hintsTaken : 0;

    return (
        <React.Fragment>
            <div className="menu">
                <div className="menu__items">
                    {!mapOpen && !reportOpen && solutionModalEnabled && hints && hintsTaken === 0 && (
                        <div
                            className={getTabClass(1)}
                            onTouchStart={() => {
                                setDragging(false);
                            }}
                            onTouchMove={() => {
                                setDragging(true);
                            }}
                            onTouchEnd={(e) => handleTouch(e, 1)}
                            onClick={(e) => handleClick(e, 1)}
                        >
                            <div className="wrapper">
                                <img src={solution} alt="reseni" width={iconSize(1)} height={iconSize(1)} />
                            </div>
                            Řešení
                        </div>
                    )}
                    {!mapOpen && !reportOpen && (!solutionModalEnabled || !hints || hintsTaken !== 0) && (
                        <div className={getTabClass(1)}>
                            <div className="wrapper wrapper__disabled">
                                <img src={solution} alt="reseni" width={iconSize(1)} height={iconSize(1)} />
                            </div>
                            <div className="wrapper__disabled">Řešení</div>
                        </div>
                    )}
                    {!reportOpen && (
                        <div
                            className={getTabClass(2)}
                            onTouchStart={() => {
                                setDragging(false);
                            }}
                            onTouchMove={() => {
                                setDragging(true);
                            }}
                            onTouchEnd={(e) => handleTouch(e, 2)}
                            onClick={(e) => handleClick(e, 2)}
                        >
                            {mapOpen && (
                                <React.Fragment>
                                    <div className="wrapper">
                                        <img src={back} alt="zpet" width={iconSize(3)} height={iconSize(3)} />
                                    </div>
                                    Zpět do hry
                                </React.Fragment>
                            )}
                            {!mapOpen && (
                                <React.Fragment>
                                    <div className="wrapper">
                                        <img src={map} alt="mapa" width={iconSize(2)} height={iconSize(2)} />
                                    </div>
                                    Mapa
                                </React.Fragment>
                            )}
                        </div>
                    )}
                    {!mapOpen && (
                        <div
                            className={getTabClass(3)}
                            onTouchStart={() => {
                                setDragging(false);
                            }}
                            onTouchMove={() => {
                                setDragging(true);
                            }}
                            onTouchEnd={(e) => handleTouch(e, 3)}
                            onClick={(e) => handleClick(e, 3)}
                        >
                            {reportOpen && (
                                <React.Fragment>
                                    <div className="wrapper">
                                        <img src={back} alt="zpet" width={iconSize(3)} height={iconSize(3)} />
                                    </div>
                                    Zpět do hry
                                </React.Fragment>
                            )}
                            {!reportOpen && (
                                <React.Fragment>
                                    <div className="wrapper">
                                        <img src={report} alt="souhrn" width={iconSize(3)} height={iconSize(3)} />
                                    </div>
                                    Pro rodiče
                                </React.Fragment>
                            )}
                        </div>
                    )}
                </div>
            </div>
        </React.Fragment>
    );
}
